/**
 * Spacing Section - Spacing scale visualization
 *
 * Shows Tailwind spacing scale with visual examples
 */
export default function SpacingSection({ theme }) {
  const isDark = theme === 'dark';

  const spacingScale = [
    { value: '0.5', pixels: '2px', class: 'w-0.5 h-0.5' },
    { value: '1', pixels: '4px', class: 'w-1 h-1' },
    { value: '2', pixels: '8px', class: 'w-2 h-2' },
    { value: '3', pixels: '12px', class: 'w-3 h-3' },
    { value: '4', pixels: '16px', class: 'w-4 h-4' },
    { value: '6', pixels: '24px', class: 'w-6 h-6' },
    { value: '8', pixels: '32px', class: 'w-8 h-8' },
    { value: '12', pixels: '48px', class: 'w-12 h-12' },
    { value: '16', pixels: '64px', class: 'w-16 h-16' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Spacing Scale
        </h2>
        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Tailwind spacing units with visual reference
        </p>
      </div>

      <div className="space-y-4">
        {spacingScale.map(space => (
          <div key={space.value} className="flex items-center gap-6">
            <div className="w-20 text-sm font-mono text-gray-500">
              {space.value} ({space.pixels})
            </div>
            <div className={`${space.class} bg-blue-500 rounded`} />
            <div className={`flex-1 h-px ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}
                 style={{ width: space.pixels }} />
          </div>
        ))}
      </div>

      {/* Spacing Examples */}
      <div>
        <h3 className={`text-lg font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Spacing in Components
        </h3>

        <div className="grid md:grid-cols-2 gap-6">
          <div className={`p-6 rounded-lg ${isDark ? 'bg-gray-800' : 'bg-white'} border ${
            isDark ? 'border-gray-700' : 'border-gray-200'
          }`}>
            <h4 className={`text-base font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
              Tight Spacing (gap-2)
            </h4>
            <div className="flex gap-2">
              <div className="w-12 h-12 bg-blue-500 rounded" />
              <div className="w-12 h-12 bg-blue-500 rounded" />
              <div className="w-12 h-12 bg-blue-500 rounded" />
            </div>
          </div>

          <div className={`p-6 rounded-lg ${isDark ? 'bg-gray-800' : 'bg-white'} border ${
            isDark ? 'border-gray-700' : 'border-gray-200'
          }`}>
            <h4 className={`text-base font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
              Comfortable Spacing (gap-4)
            </h4>
            <div className="flex gap-4">
              <div className="w-12 h-12 bg-green-500 rounded" />
              <div className="w-12 h-12 bg-green-500 rounded" />
              <div className="w-12 h-12 bg-green-500 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
